import { useEffect, useState } from "react";
import { isPreviewMode } from "../lib/sanity";

const PreviewBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(isPreviewMode());
  }, []);

  if (!visible) return null;

  const exitPreview = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("preview");
    window.location.href = url.toString();
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        background: "#ff6b00",
        color: "#fff",
        padding: "10px 16px",
        fontFamily: "system-ui, -apple-system, sans-serif",
        fontSize: "14px",
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
      <span>⚠️ PREVIEW MODE — viewing draft content (not yet published)</span>
      <button
        onClick={exitPreview}
        style={{
          background: "rgba(255,255,255,0.2)",
          color: "#fff",
          border: "1px solid rgba(255,255,255,0.4)",
          padding: "4px 12px",
          borderRadius: "4px",
          cursor: "pointer",
          fontSize: "13px",
          fontWeight: 600,
        }}
        onMouseEnter={(e) => (e.target.style.background = "rgba(255,255,255,0.3)")}
        onMouseLeave={(e) => (e.target.style.background = "rgba(255,255,255,0.2)")}
      >
        Exit Preview
      </button>
    </div>
  );
};

export default PreviewBanner;
